var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityBoost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 113,
    viewBox: "0 0 118 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4233 101.053L26.5165 102.014C26.5165 102.014 19.5948 96.705 14.6807 90.3646L15.3318 89.6748C15.3318 89.6748 20.4319 95.4028 27.4233 101.053Z",
    fill: "url(#paint0_linear_246_104)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3315 89.6748C20.2844 95.6121 27.4231 101.053 27.4231 101.053C27.4231 101.053 33.8565 93.2403 40.2511 85.9621C40.4139 85.7761 40.5689 85.5901 40.7316 85.4118C43.3592 82.4354 45.4133 80.2418 46.8937 78.7071C48.8315 76.6919 49.8004 75.816 49.8004 75.816L46.6147 73.1807C46.6147 73.1807 46.1574 73.5682 44.4831 75.1882C43.398 76.2423 41.809 77.8158 39.4837 80.1411C39.0109 80.6216 38.5459 81.0867 38.1118 81.5363C33.1434 86.6752 30.7328 90.1709 29.2756 90.9228C27.8262 91.6746 18.7963 87.7061 18.7963 87.7061C16.719 88.3804 15.3315 89.6748 15.3315 89.6748Z",
    fill: "url(#paint1_linear_246_104)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3315 89.6748C20.2844 95.6121 27.4231 101.053 27.4231 101.053C27.4231 101.053 33.8565 93.2402 40.2511 85.962C40.4139 85.776 40.5689 85.59 40.7316 85.4117L38.1196 81.5439C33.1511 86.6829 30.7406 90.1786 29.2834 90.9304C27.8339 91.6823 18.804 87.7138 18.804 87.7138C16.7267 88.3881 15.3393 89.6825 15.3393 89.6825L15.3315 89.6748Z",
    fill: "url(#paint2_linear_246_104)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.268 90.9227L30.6089 95.4493C30.6089 95.4493 27.5317 94.8447 23.6717 92.2482C19.8195 89.6516 18.7886 87.7061 18.7886 87.7061C18.7886 87.7061 27.2914 91.1863 29.268 90.9227Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4756 75.1881C45.429 76.188 46.3901 77.4204 46.8862 78.6993C48.8239 76.6841 49.7928 75.8082 49.7928 75.8082L46.6071 73.1729C46.6071 73.1729 46.1498 73.5604 44.4756 75.1804V75.1881Z",
    fill: "#5E364C"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.81 63.3674C29.8104 63.0109 23.9739 62.5458 16.9282 59.1198C16.5562 58.9338 16.1764 58.74 15.7966 58.5463C8.23933 54.5855 6.18531 48.1366 6.18531 48.1366C6.18531 48.1366 4.03827 47.0205 2.79811 45.3773C1.55795 43.7341 0.922363 37.6185 0.922363 37.6185L2.3253 36.8977L2.6896 35.704L5.89852 35.3165L6.75888 34.5646L9.526 34.7351C9.526 34.7351 11.0685 32.0223 10.9367 28.6738C10.9367 28.6738 13.7038 28.8443 14.4246 30.3946C14.4246 30.3946 12.3319 33.867 11.9366 38.1843C11.611 41.7731 12.3241 42.897 12.3241 42.897C12.3241 42.897 13.3318 42.8039 14.2696 42.3311C15.2075 41.8583 16.0756 41.2227 16.5562 41.215C17.029 41.1917 19.8039 42.8039 20.1061 44.2534C20.1061 44.2534 20.1061 46.4624 19.0365 46.881C19.0365 46.881 16.0524 44.5324 15.5253 44.5789C14.9982 44.6409 13.4945 46.5012 13.4945 46.5012C13.4945 46.5012 12.0451 46.8035 11.2235 46.7105C11.2235 46.7105 14.1689 53.3376 18.5482 55.8489C23.6484 58.7633 30.6863 59.1896 30.6863 59.1896C30.6863 59.1896 29.6089 56.8643 33.0194 57.0736C36.4298 57.2829 39.9798 58.8873 40.2201 60.6933C40.2743 61.1429 40.1735 61.5614 39.9178 61.918C39.1349 63.0264 36.9646 63.6542 33.8022 63.3752L33.81 63.3674Z",
    fill: "url(#paint3_linear_246_104)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9282 59.112C16.5562 58.926 16.1764 58.7322 15.7966 58.5384C8.23934 54.5776 6.18532 48.1288 6.18532 48.1288C6.18532 48.1288 4.03828 47.0126 2.79812 45.3694C1.55796 43.7262 0 38.0757 0 38.0757L2.32531 36.882L2.68961 35.6884L5.89853 35.3008L6.75889 34.549L9.52601 34.7195C9.52601 34.7195 11.0685 32.0066 10.9367 28.6582C10.9367 28.6582 13.7038 28.8287 14.4247 30.3789C14.4247 30.3789 12.4947 34.4792 12.2234 38.0679C11.9676 41.3621 12.0838 41.7729 12.0838 41.7729C12.0838 41.7729 13.1457 42.6255 14.0836 42.1605C15.0215 41.6877 16.0911 41.2149 16.5717 41.2071C17.0445 41.1839 19.8194 42.7961 20.1217 44.2455C20.1217 44.2455 20.1217 46.4546 19.052 46.8731C19.052 46.8731 16.0679 44.5245 15.5408 44.5711C15.0137 44.6331 13.51 46.4933 13.51 46.4933C13.51 46.4933 12.0606 46.7956 11.239 46.7026C11.239 46.7026 14.1844 53.3297 18.5637 55.841C18.5637 55.841 18.9358 58.0966 16.936 59.112H16.9282Z",
    fill: "url(#paint4_linear_246_104)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5158 61.3371C29.5158 61.3371 28.9809 58.8335 32.2596 59.7869C35.5383 60.7402 38.6465 63.0965 38.4759 64.9103C38.4294 65.3598 38.2357 65.7474 37.9101 66.0419C37.9644 62.7167 29.5158 61.3371 29.5158 61.3371Z",
    fill: "#5E364C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.281 52.7329C111.196 62.1814 106.422 71.0641 102.399 74.3583C102.399 74.3583 92.8651 81.5823 76.8592 78.9159L70.0305 75.1644C70.0305 75.1644 54.5207 78.9392 35.9493 73.4592C35.9493 73.4592 25.6482 62.8403 24.9428 44.6719C24.9428 44.6486 24.9428 44.6331 24.9428 44.6331C24.7026 38.2695 25.6327 30.9681 28.6091 22.876C28.6091 22.876 46.9868 8.65287 63.7367 8.86215C80.4867 9.07918 111.77 16.7217 116.382 28.418C118.629 34.1305 117.227 43.6953 114.281 52.7329Z",
    fill: "url(#paint5_linear_246_104)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.204 33.2391C43.204 33.2391 50.6605 39.3392 54.1562 40.7344C57.6597 42.1296 63.721 40.4941 66.6354 38.8044C69.5498 37.1224 71.2705 31.0068 71.2705 31.0068C71.2705 31.0068 71.5883 35.5412 71.162 37.1999C70.7357 38.8586 58.9929 45.4237 55.6754 45.0439C52.358 44.6641 45.1961 36.5566 45.1961 36.5566L43.1963 33.2391H43.204Z",
    fill: "url(#paint6_linear_246_104)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1362 38.3394C27.1362 38.3394 29.6553 42.8892 32.1666 44.1759C34.678 45.4625 37.8947 39.6648 37.8947 39.6648C37.8947 39.6648 34.7245 48.3847 31.7636 48.5862C28.8027 48.7877 27.2835 39.8198 27.1362 38.3394Z",
    fill: "url(#paint7_linear_246_104)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9751 18.9697C77.9751 18.9697 82.8737 26.775 91.6944 29.6119C100.515 32.4488 109.754 32.4643 109.754 32.4643C109.754 32.4643 96.7946 35.4019 87.6949 32.038C78.5952 28.674 77.9751 18.9697 77.9751 18.9697Z",
    fill: "url(#paint8_linear_246_104)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7451 30.4956C55.7451 30.4956 56.7062 31.7435 60.4965 32.9682C64.2867 34.1928 65.5812 32.0691 65.5812 32.0691C65.5812 32.0691 66.3098 33.689 66.0772 34.5416C65.8447 35.3943 61.3956 37.6188 59.5509 36.7584C57.7061 35.8981 55.7451 30.5034 55.7451 30.5034V30.4956Z",
    fill: "url(#paint9_linear_246_104)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8257 33.5649C32.8257 33.5649 33.624 34.7896 34.7402 35.0144C35.8641 35.2392 36.6237 33.9292 36.6237 33.9292C36.6237 33.9292 36.7089 35.8903 36.2051 36.8514C35.7013 37.8048 33.3373 38.6729 32.6939 38.045C32.0428 37.4172 31.7793 34.4486 31.7793 34.4486L32.8257 33.5727V33.5649Z",
    fill: "url(#paint10_linear_246_104)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3271 10.3353C53.3271 10.3353 44.0568 15.885 41.251 21.0627C38.4451 26.2404 40.5146 54.1518 45.9403 63.9569C45.9403 63.9569 39.1504 36.4252 43.3825 21.0239C43.3825 21.0239 48.4129 11.9552 57.2181 9.45166L53.3348 10.3353H53.3271Z",
    fill: "#FF7F85"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1389 9.24994C70.1389 9.24994 60.2021 14.9392 54.5981 16.7297C48.9941 18.5202 43.7312 19.427 43.7312 19.427L41.7856 23.6126C41.7856 23.6126 52.2418 17.8148 56.7994 16.6599C61.357 15.505 74.0919 9.6995 74.0919 9.6995L70.1466 9.24219L70.1389 9.24994Z",
    fill: "#FF7F85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3521 17.1948C37.3521 17.1948 37.0421 19.7217 37.4607 20.4115C37.8715 21.1091 42.8244 19.9309 42.8244 19.9309L41.1346 23.4344C41.1346 23.4344 37.4296 21.4269 36.8251 20.396C36.2205 19.3574 35.6392 18.1947 35.6392 18.1947L37.3521 17.1948Z",
    fill: "#FF7F85"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4369 35.4561C41.4369 35.4561 47.506 39.6649 55.3965 45.3774C55.3965 45.3774 65.6124 45.1138 72.5031 37.0218C72.5031 37.0218 73.9913 25.9843 68.7128 19.6982C68.7128 19.6982 60.1634 19.7525 54.6757 24.2016C54.6757 24.2016 53.4355 32.8362 58.4505 38.1534C58.4505 38.1534 63.2251 38.0527 66.434 34.8515C66.434 34.8515 66.31 29.3638 65.3566 26.5889L66.1705 25.2945L59.8844 27.8058L64.6048 27.4415C64.6048 27.4415 66.2945 31.0302 65.2326 34.0996C65.2326 34.0996 62.1089 37.2233 58.8535 36.6962C58.8535 36.6962 54.1564 29.9839 55.7143 24.5194C55.7143 24.5194 60.6052 19.737 68.147 21.2097C68.147 21.2097 72.5263 28.2166 70.294 37.0838C70.294 37.0838 66.2557 43.9047 55.009 44.207C55.009 44.207 49.0717 40.223 46.6224 36.8435C44.1731 33.4641 41.8633 27.519 41.8633 27.519L41.4292 35.4483L41.4369 35.4561Z",
    fill: "#FF7F85"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7857 34.3401C40.7857 34.3401 39.623 35.9601 38.2046 40.5409C36.7862 45.1218 32.2983 49.7802 31.0117 49.5631C29.725 49.3461 27.2602 42.3547 26.9191 38.7892C26.5781 35.2237 29.3994 28.9299 30.035 27.6975C30.6706 26.4651 34.9879 24.6281 36.3366 25.0544C37.6853 25.4807 37.2357 35.1075 36.6389 36.991C36.0421 38.8745 33.0812 38.9442 32.5619 38.4792C32.0425 38.0141 31.1124 34.2549 31.1124 34.2549L29.9885 33.9371L34.4764 31.697L32.1898 34.5572C32.1898 34.5572 32.0115 37.1692 32.7634 37.7971C33.5152 38.4249 35.0887 37.6886 35.9956 36.6499C36.9024 35.6113 36.7474 27.0077 35.5925 25.9845C34.4376 24.9536 31.1744 26.9844 30.2055 29.0539C29.2367 31.1235 27.5935 35.7276 27.6555 38.5722C27.7252 41.4168 29.1669 46.827 31.2054 47.8502C34.1276 49.3151 37.0109 41.7966 37.9411 38.5102C38.8634 35.216 40.3749 24.2793 40.3749 24.2793L40.7857 34.3401Z",
    fill: "#FF7F85"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5009 50.4235C25.5009 50.4235 27.9657 57.1126 28.8649 57.5776C29.764 58.0427 30.0508 51.7024 37.9103 51.5086L43.0027 52.9425C43.0027 52.9425 46.3744 48.819 48.9943 48.4624C48.9943 48.4624 58.7141 45.9046 70.3251 49.5786C70.3251 49.5786 79.8278 38.8434 82.967 38.1691C86.1062 37.4947 97.2754 38.8744 99.6162 42.8507C99.6162 42.8507 98.9264 54.8958 93.7642 63.6545C93.7642 63.6545 86.765 67.654 79.9053 64.6698C79.9053 64.6698 77.4715 56.7638 83.4631 47.5711C83.4631 47.5711 88.4082 44.866 93.6402 46.7417C93.6402 46.7417 92.9193 55.2368 89.7802 60.4765C89.7802 60.4765 93.5704 50.8885 91.3924 47.9044C91.3924 47.9044 87.2611 46.6177 83.7499 49.0593C80.2386 51.5086 80.9362 62.9336 81.7733 63.8405C82.6105 64.7473 90.9661 64.197 93.3301 61.988C95.6942 59.7789 99.3217 44.5947 96.8181 42.0523C96.8181 42.0523 88.4857 38.3629 82.2927 40.0836C82.2927 40.0836 74.4719 45.5248 70.3638 52.834C70.3638 52.834 54.823 51.9969 50.2034 51.7256C45.5838 51.4543 44.3514 56.3995 44.3514 56.3995C44.3514 56.3995 40.4836 54.2447 38.7164 54.0199C36.9492 53.7952 28.1285 60.2828 28.1285 60.2828C28.1285 60.2828 26.0357 55.7097 25.4932 50.4312L25.5009 50.4235Z",
    fill: "#FF7F85"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.382 28.4185C116.382 28.4185 114.08 33.4179 109.817 33.5031C105.554 33.5884 94.1597 34.8751 86.4939 32.3327C78.8359 29.7904 75.2084 17.7066 76.7509 16.3114C78.3011 14.9162 86.1296 13.087 93.9039 14.8774C101.043 16.5207 103.523 21.8611 103.546 22.4734C103.569 23.0858 102.205 29.7517 100.43 30.3485C98.6553 30.9531 86.3234 25.9769 85.0367 22.3417C83.9361 19.2258 85.8661 17.3345 87.0752 17.1562C88.2767 16.978 97.9034 20.8767 97.9034 20.8767L100.376 20.3187L98.3762 22.3882L98.0042 24.853L96.8028 21.3108C96.8028 21.3108 89.9664 18.1406 88.3232 18.1949C86.6799 18.2491 84.9825 20.0164 85.4088 21.6983C86.3001 25.1553 98.5158 29.1083 100.229 29.0076C101.942 28.9145 102.608 22.7602 102.244 21.5046C101.88 20.2489 97.8569 17.102 92.563 15.699C83.7423 13.366 78.4794 15.6835 78.0221 17.3888C77.5647 19.094 80.5566 28.31 86.1761 30.8988C91.7956 33.4876 106.546 34.2783 110.832 31.5344C115.118 28.7828 113.723 24.481 113.723 24.481C113.723 24.481 115.987 27.2636 116.374 28.4185H116.382Z",
    fill: "#FF7F85"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.715 41.9902C116.715 41.9902 109.747 38.3163 107.305 39.4479C104.872 40.5796 101.089 58.1279 102.663 60.7555C104.236 63.3831 110.483 62.2824 110.483 62.2824L111.894 59.1045C111.894 59.1045 107.298 62.732 104.259 60.5307C101.221 58.3294 105.344 43.3157 107.484 40.8353C109.623 38.355 116.878 42.5948 116.436 44.6023L116.707 41.9825L116.715 41.9902Z",
    fill: "#FF7F85"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.413 48.9429C115.413 48.9429 112.894 46.3075 111.39 46.1757C109.886 46.044 107.662 55.0429 107.662 55.0429L109.336 55.5157C109.336 55.5157 108.274 54.6089 108.576 53.5392C108.879 52.4696 110.08 47.7337 111.576 47.5477C113.072 47.3617 114.909 50.0513 114.273 52.7176C114.273 52.7176 115.234 49.6095 115.405 48.9506L115.413 48.9429Z",
    fill: "#FF7F85"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.281 52.7333C111.196 62.1818 106.422 71.0644 102.399 74.3586C102.399 74.3586 92.8651 81.5826 76.8592 78.9162L70.0306 75.1647C70.0306 75.1647 54.5208 78.9395 35.9493 73.4595C35.9493 73.4595 25.6482 62.8406 24.9429 44.6722C25.0281 45.2923 26.9039 53.1208 28.9114 54.9888C31.2367 57.1513 28.8339 77.3195 51.1103 74.3431C68.5501 72.0178 68.3331 50.4622 68.3331 50.4622L77.7118 43.8506C77.7118 43.8506 80.7968 49.005 85.0986 48.2919C85.0986 48.2919 87.0286 50.7025 92.0512 50.9583C92.0512 50.9583 97.3607 51.152 98.6241 49.9351C98.6241 49.9351 102.352 50.9428 104.143 49.8654C104.143 49.8654 110.754 53.3068 114.266 52.71V52.7333H114.281Z",
    fill: "url(#paint11_linear_246_104)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3433 53.981C45.3433 53.981 46.6609 48.0514 51.1178 44.858C56.4427 41.0445 67.1391 43.6566 68.5576 51.0433C68.5576 51.0433 54.5205 49.1521 45.3433 53.981Z",
    fill: "#E16070"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.312 56.6941C50.312 56.6941 51.2886 64.3134 57.7995 65.7086C64.3104 67.1037 67.5813 58.9187 67.9146 56.2523C68.2401 53.586 50.312 56.6941 50.312 56.6941Z",
    fill: "#E16070"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5933 58.523C30.5933 58.523 31.7017 67.8165 36.3058 68.2118C40.9099 68.6071 41.0649 57.6704 40.2975 55.0815L30.5933 58.5152V58.523Z",
    fill: "#E16070"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5933 58.5233C30.5933 58.5233 31.4381 67.4912 36.7398 66.6696C42.0415 65.848 40.189 54.4153 40.189 54.4153L39.755 54.0742C39.755 54.0742 32.2442 48.8423 30.5933 58.5233Z",
    fill: "url(#paint12_linear_246_104)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.374 51.733C49.374 51.733 50.1491 65.4136 59.5124 64.5144C68.8756 63.6153 68.5656 51.0431 68.5656 51.0431C68.3485 49.741 58.3342 37.3858 49.374 51.733Z",
    fill: "url(#paint13_linear_246_104)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.233 60.7941C59.5201 60.7941 57.3188 58.5928 57.3188 55.88C57.3188 53.1671 59.5201 50.9658 62.233 50.9658C64.9459 50.9658 67.1471 53.1671 67.1471 55.88C67.1471 58.5928 64.9459 60.7941 62.233 60.7941Z",
    fill: "#37193E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8869 64.7316C36.4994 64.8169 35.267 63.2124 35.143 61.1507C35.019 59.0889 36.0421 57.3527 37.4373 57.2674C38.8247 57.1821 40.0571 58.7866 40.1812 60.8484C40.3052 62.9102 39.282 64.6464 37.8869 64.7316Z",
    fill: "#37193E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.437 66.8012C43.6616 66.8012 49.3353 65.4525 51.118 64.0186C51.118 64.0186 50.7382 70.1031 47.8704 70.7154C44.0104 71.5371 41.437 66.8012 41.437 66.8012Z",
    fill: "url(#paint14_linear_246_104)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1739 37.1301L40.7861 34.3398L45.8553 38.4013L43.9175 32.9291L41.2511 27.5576L38.8716 36.0295L39.1739 37.1301Z",
    fill: "#E16070"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0112 20.6127L41.8635 23.3488C41.8635 23.3488 46.8939 20.4577 48.3666 18.4502C48.3666 18.4502 44.4678 20.3569 42.8944 20.5895C41.3209 20.822 38.019 20.6127 38.019 20.6127H38.0112Z",
    fill: "#E16070"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9888 33.9368L31.1204 34.2546L32.1901 35.7118V34.5569L34.4766 31.6968L29.9888 33.9368Z",
    fill: "#E16070"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8843 27.8058L66.1781 25.2944L65.3643 26.5889L65.1472 28.9529L64.6124 27.4492L59.8843 27.8058Z",
    fill: "#E16070"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6987 34.7432C57.6987 34.7432 59.1326 36.7662 59.5512 36.7507C59.9698 36.7429 61.861 36.2934 61.861 36.2934C61.861 36.2934 60.7061 38.2931 58.7528 38.1304C58.7528 38.1304 57.5127 37.5645 57.6987 34.7432Z",
    fill: "#E16070"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6802 25.3955C80.6802 25.3955 81.9281 29.2013 87.4856 31.4181C93.0431 33.6348 100.244 33.255 100.244 33.255C100.244 33.255 90.9115 34.1154 86.5012 32.3404C82.0909 30.5732 80.6802 25.3955 80.6802 25.3955Z",
    fill: "#E16070"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8027 21.3106L98.0041 24.8605L98.3762 22.3957L100.376 20.3262L96.8027 21.3106Z",
    fill: "#E16070"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9483 52.0123L42.2818 52.7331L37.8948 50.2063C37.8948 50.2063 30.6011 48.2996 29.1206 58.0504C29.1206 58.0504 31.2831 51.5007 37.8948 52.5006L43.2895 55.7638L44.4831 57.3295L47.1417 52.7564L49.9941 47.2842C49.9941 47.2842 47.3898 48.2066 43.9561 52.0201L43.9483 52.0123Z",
    fill: "#E16070"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1813 54.4152C40.1813 54.4152 33.1821 49.5709 30.5855 58.5233L29.1051 58.7791C28.5315 57.0583 33.9727 46.889 40.1736 54.4152H40.1813Z",
    fill: "#4B3052"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5447 53.2523L46.5684 53.9422C46.5684 53.9422 49.3975 45.509 57.319 44.8735C65.9692 44.1836 68.558 51.0433 68.558 51.0433C67.2093 47.4468 53.366 41.7498 49.537 53.2523H49.5447Z",
    fill: "#4B3052"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8959 46.5091C29.8959 46.5091 30.6865 47.9508 32.0275 48.0438C33.3684 48.1291 35.1279 45.3154 35.1279 45.3154C35.1279 45.3154 33.7869 48.5089 31.8957 49.2995C31.8957 49.2995 30.3998 50.3924 29.8882 46.5168L29.8959 46.5091Z",
    fill: "#E16070"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.933 50.4233L107.662 55.0352L109.336 55.508C109.336 55.508 108.421 54.6321 108.576 53.5315C108.731 52.4309 108.933 50.4233 108.933 50.4233Z",
    fill: "#E16070"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5942 63.7708C89.5942 63.7708 92.2063 63.205 93.7023 61.6548C95.1982 60.1046 96.6632 54.2061 96.6632 54.2061C96.6632 54.2061 96.1361 60.3604 93.772 63.6468C93.772 63.6468 91.6405 64.3909 89.5942 63.7708Z",
    fill: "#E16070"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.856 72.9633C103.856 72.9633 99.9959 76.2265 88.8887 74.9166C75.5957 73.3509 69.3794 75.3041 69.3794 75.3041C69.3794 75.3041 74.5726 78.8231 78.6574 79.1564C82.7422 79.4897 96.3685 80.4121 103.856 72.9556V72.9633Z",
    fill: "url(#paint15_linear_246_104)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8692 57.1435C58.6832 57.8024 58.0011 58.1822 57.3422 57.9961C56.6834 57.8101 56.3036 57.128 56.4896 56.4692C56.6756 55.8103 57.3577 55.4305 58.0166 55.6166C58.6754 55.8026 59.0552 56.4847 58.8692 57.1435Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3832 62.7938C36.2515 63.2588 35.7709 63.5301 35.3058 63.3984C34.8408 63.2666 34.5695 62.786 34.7013 62.321C34.833 61.8559 35.3136 61.5846 35.7786 61.7164C36.2437 61.8482 36.515 62.3287 36.3832 62.7938Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7075 54.2061C51.1182 48.5866 61.086 43.8429 68.496 52.7101C68.496 52.7101 68.5657 51.7102 68.5657 51.0437C68.5037 48.9586 55.389 38.5412 49.3354 53.2992L49.7075 54.2061Z",
    fill: "#D8CBD9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.756 59.5772C30.3374 56.2908 35.9104 51.4696 40.3285 55.5544C40.3285 55.5544 40.2975 55.0971 40.1812 54.4228C40.1812 54.4228 31.8954 49.2993 30.5854 58.5308C30.5854 58.5308 30.632 59.3214 30.7482 59.5772H30.756Z",
    fill: "#D8CBD9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8003 34.4792C49.8003 34.4792 44.8629 30.4255 45.1652 27.2475C45.4752 24.0696 51.0482 21.039 51.0482 21.039C51.0482 21.039 54.4742 17.489 57.8304 17.0239C61.1866 16.5589 65.6511 17.2332 65.6511 17.2332C65.6511 17.2332 59.7139 20.2484 57.4893 20.5894C55.2725 20.9304 52.1256 20.3646 50.5444 21.7133C48.9632 23.062 47.3355 24.7905 49.157 27.7436C50.9862 30.6967 49.7925 34.4792 49.7925 34.4792H49.8003Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.498 37.572C51.498 37.572 56.0091 36.7504 57.0013 40.3624C57.0013 40.3624 53.6761 41.0832 51.498 37.572Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3451 37.0762C30.3451 37.0762 32.0194 39.4945 32.4147 40.5719C32.8177 41.6493 32.748 42.1763 32.748 42.1763C32.748 42.1763 33.337 39.6728 35.1198 39.293C35.1198 39.293 34.3447 43.091 32.686 43.6103C32.686 43.6103 29.5623 41.099 30.3451 37.0762Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2628 21.9228C72.2628 21.9228 74.1618 29.511 74.6501 32.5727C75.1462 35.6344 74.2935 37.9597 73.4874 38.5642C72.6813 39.1688 67.4261 42.6568 67.2246 45.7882C67.2246 45.7882 69.1159 46.54 71.3326 44.3853C73.5494 42.2382 73.5029 38.9828 75.0686 37.0605C76.6343 35.1383 78.8356 33.7276 78.8046 31.4333C78.7736 29.139 75.3089 27.5965 74.0145 25.6588C72.7123 23.721 73.4797 23.0932 72.2705 21.915L72.2628 21.9228Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9746 34.5802C83.9746 34.5802 87.5091 32.9525 90.749 35.1383C90.749 35.1383 88.2532 38.0914 83.9746 34.5802Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3462 41.9362C86.3462 41.9362 89.8807 40.3084 93.1206 42.4942C93.1206 42.4942 90.6248 45.4474 86.3462 41.9362Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5728 15.1096C72.5728 15.1096 72.534 12.4976 75.2236 11.3969C77.9132 10.2963 82.2383 12.0015 82.2383 12.0015C82.2383 12.0015 78.2853 13.7532 76.4328 13.2494C74.5803 12.7533 72.5728 15.1096 72.5728 15.1096Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9341 36.9289C99.9341 36.9289 103.523 35.34 106.654 35.3865C109.786 35.433 110.646 36.6344 112.948 36.2546C115.25 35.8748 116.056 33.0146 116.056 33.0146C116.056 33.0146 116.537 35.929 115.498 37.8823C114.46 39.8278 111.568 36.5259 109.22 36.1151C106.871 35.7043 107.305 38.3706 105.205 38.8667C103.112 39.3627 99.9418 36.9367 99.9418 36.9367L99.9341 36.9289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.763 31.379C100.763 31.379 101.251 30.0691 102.918 30.1853C104.584 30.3016 106.127 28.5886 106.476 27.8135C106.817 27.0462 106.53 25.4572 109.026 25.3564C109.026 25.3564 110.343 26.9454 109.32 28.9839C108.297 31.0224 105.84 29.8443 104.809 30.2008C103.778 30.5496 103.414 31.9603 102.84 31.9603C102.267 31.9603 100.763 31.379 100.763 31.379Z",
    fill: "white"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.244 37.1535C100.244 37.1535 104.143 34.4639 108.77 35.9831C108.77 35.9831 106.964 39.0292 104.771 38.7424C102.577 38.4557 100.244 37.1612 100.244 37.1612V37.1535Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7354 25.2246C73.7354 25.2246 73.9446 28.7281 74.8748 31.5572C75.8126 34.3863 77.2776 34.6809 77.2776 34.6809C77.2776 34.6809 79.6339 32.4331 78.3705 30.0767C77.107 27.7282 73.7354 25.2246 73.7354 25.2246Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4369 66.8012C41.4369 66.8012 48.9167 64.8867 51.118 64.0186C51.118 64.0186 52.3271 70.8705 48.5989 72.2966C44.7389 73.7771 41.4292 66.8012 41.4292 66.8012H41.4369Z",
    fill: "url(#paint16_linear_246_104)"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6138 19.6439C52.6138 19.6439 54.257 20.7058 57.7449 19.6982C61.2329 18.6905 62.7056 16.9388 62.7056 16.9388C62.7056 16.9388 55.3111 15.9622 52.6138 19.6517V19.6439Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2188 14.4896C50.2188 14.4896 53.6137 15.195 57.6752 12.6139C61.7368 10.0328 61.7523 9.11816 61.7523 9.11816C61.7523 9.11816 52.079 10.5289 50.2188 14.4896Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.856 17.6134C38.856 17.6134 40.0419 18.0862 42.2974 16.9081C44.553 15.7299 45.7311 13.8154 45.7311 13.8154C45.7311 13.8154 39.7086 15.6214 38.856 17.6134Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0195 23.8218C30.0195 23.8218 33.0192 25 36.0731 22.0081C36.0731 22.0081 32.7169 20.8765 30.0195 23.8218Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7466 44.8502C44.7466 44.8502 46.3355 48.0436 50.5056 44.4394C50.5056 44.4394 46.258 40.3314 44.7466 44.8502Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1393 66.5143C66.1393 66.5143 69.2164 68.3125 70.7201 63.0031C70.7201 63.0031 64.9069 61.9024 66.1393 66.5143Z",
    fill: "white"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6328 20.9849C88.6328 20.9849 93.3067 19.6828 96.0273 23.0622C96.0273 23.0622 93.5935 24.5737 88.6328 20.9849Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9594 39.0058C81.9594 39.0058 85.3389 39.3934 90.1212 40.0367C94.9036 40.6723 95.8492 40.0677 95.8492 40.0677C95.8492 40.0677 88.447 37.2308 83.4244 38.0912C83.4244 38.0912 82.3935 38.2462 81.9517 39.0058H81.9594Z",
    fill: "#E16070"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9304 110.688C67.3563 111.199 79.7811 110.51 79.7811 110.51C79.7811 110.51 79.1146 104.541 79.1146 93.7441C79.1146 92.4109 79.1378 91.101 79.1843 89.8375C79.2851 86.8224 79.4711 84.156 79.6804 81.9547C80.0834 77.6374 80.5407 74.3742 80.5407 74.3742C79.4789 74.3122 76.3397 74.3742 76.3397 74.3742C75.9831 76.4593 75.5026 79.6139 75.3011 81.3967C74.9678 84.3963 74.8127 87.0859 74.6577 89.8298C74.3012 95.9918 74.3012 100.363 73.6113 101.247C72.1464 103.123 64.3799 106.533 64.3799 106.533C62.8762 108.479 62.9304 110.68 62.9304 110.68V110.688Z",
    fill: "url(#paint17_linear_246_104)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9304 110.688C67.4648 111.703 79.7811 110.509 79.7811 110.509C79.7811 110.509 79.1146 104.541 79.1146 93.7439C79.1146 92.4107 79.1378 91.1008 79.1843 89.8374H74.6577C74.3012 95.9995 74.3012 100.371 73.6113 101.255C72.1464 103.13 64.3799 106.541 64.3799 106.541C62.8762 108.486 62.9304 110.688 62.9304 110.688Z",
    fill: "url(#paint18_linear_246_104)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9307 110.688V112.122C62.9307 112.122 68.4881 112.804 79.7814 112.308V110.502C79.7814 110.502 67.434 111.331 62.9307 110.68V110.688Z",
    fill: "url(#paint19_linear_246_104)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6114 101.247L77.8667 104.611C77.8667 104.611 68.6198 106.998 64.3877 106.533C64.3877 106.533 71.8674 103.169 73.6192 101.247H73.6114Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3013 81.3966C76.5569 81.2183 78.1226 81.2416 79.6806 81.9469C80.0837 77.6296 80.541 74.3664 80.541 74.3664C79.5256 74.3044 76.3399 74.3664 76.3399 74.3664C75.9834 76.4515 75.5028 79.6061 75.3013 81.3889V81.3966Z",
    fill: "#5E364C"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44169 42.5483C1.44169 42.5483 5.35596 42.6568 6.8054 42.3545C6.8054 42.3545 9.464 40.6958 10.3554 39.2851L9.52601 34.7197L2.95314 38.6107L0 38.0837C0 38.0837 1.08514 41.6259 1.44169 42.5483Z",
    fill: "#FF7F85"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 38.0836C0 38.0836 1.03864 40.8119 2.40282 41.9281L4.12355 41.0445L4.43359 41.4708L6.8209 40.9282L6.89066 40.2616L9.16946 39.7733C9.16946 39.7733 9.77404 37.1069 9.52601 34.7196C9.52601 34.7196 8.17733 34.3476 6.75889 34.5491L5.89853 35.301C5.89853 35.301 5.03042 35.0994 2.68961 35.6885L2.30981 37.1302C2.30981 37.1302 1.65097 37.0527 0 38.0681L0 38.0836Z",
    fill: "url(#paint20_linear_246_104)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2311 46.7031L8.72754 47.7263L11.983 48.1913L11.2311 46.7031Z",
    fill: "#FF7F85"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89838 35.3086C5.89838 35.3086 6.29368 38.1609 6.89051 40.2615C6.89051 40.2615 6.34794 36.1224 6.31693 34.9365L5.89062 35.3086H5.89838Z",
    fill: "#FF7F85"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32517 36.8901C2.32517 36.8901 3.3328 39.975 4.1234 41.0447C4.1234 41.0447 2.42593 39.0449 1.8291 37.2157L2.32517 36.8901Z",
    fill: "#FF7F85"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.747 96.263C109.747 96.263 110.026 94.5035 109.909 93.3951C109.793 92.2867 109.204 90.2017 109.204 90.2017C109.204 90.2017 109.964 92.0852 110.266 93.4726C110.568 94.8678 110.32 95.7359 110.32 95.7359L110.809 95.9142L109.739 96.263H109.747Z",
    fill: "#FF7F85"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.871 91.6976C110.871 91.6976 111.39 93.8989 110.809 95.9142L109.739 96.263C109.739 96.263 109.654 97.2474 109.336 98.2628L108.305 98.5961L107.716 100.022C107.716 100.022 106.701 100.534 105.755 99.7432L105.515 98.7278L104.158 98.6193C104.158 98.6193 103.081 95.7204 103.12 92.744C103.12 92.744 102.569 90.0544 101.631 88.5895C101.631 88.5895 101.097 88.729 101.352 89.9227C101.383 90.0312 102.321 92.9301 102.096 94.705C102.096 94.705 100.662 95.5577 99.6393 94.9376C99.6393 94.9376 99.6393 93.2013 98.9805 90.8605C98.3062 88.5275 97.5698 87.4423 97.4768 87.0238C97.3916 86.5897 98.3604 84.5357 99.7401 83.1793C99.7401 83.1793 99.0348 78.7612 96.787 73.4982C95.3143 70.0025 93.1517 66.1348 90.0901 62.9336L90.0048 62.9801C89.5785 63.1739 87.788 63.8172 86.6641 61.1974C85.3852 58.2055 86.2688 54.7563 88.9274 54.3145C88.9274 54.3145 89.811 55.1051 91.3302 57.0583C93.299 59.5774 96.3219 64.042 99.8874 71.2349C101.476 74.4439 103.174 78.2109 104.926 82.5824C104.926 82.5824 109.336 88.1167 110.863 91.6899L110.871 91.6976Z",
    fill: "url(#paint21_linear_246_104)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.871 91.6976C110.871 91.6976 111.39 93.8989 110.809 95.9141L109.739 96.2629C109.739 96.2629 109.654 97.2473 109.336 98.2627L108.305 98.596L107.716 100.022C107.716 100.022 106.701 100.534 105.755 99.7431L105.515 98.7277L104.158 98.6192C104.158 98.6192 103.081 95.7203 103.12 92.744C103.12 92.744 102.569 90.0543 101.631 88.5894C101.631 88.5894 101.097 88.7289 101.352 89.9226C101.383 90.0311 102.321 92.93 102.097 94.705C102.097 94.705 100.663 95.5576 99.6395 94.9375C99.6395 94.9375 99.6395 93.2013 98.9806 90.8605C98.3063 88.5274 97.57 87.4423 97.477 87.0237C97.3917 86.5896 98.3606 84.5356 99.7402 83.1792C99.7402 83.1792 99.0349 78.7611 96.7871 73.4982C96.7871 73.4982 97.3762 71.8007 99.8875 71.2349C101.476 74.4438 103.174 78.2108 104.926 82.5824C104.926 82.5824 109.336 88.1166 110.863 91.6898L110.871 91.6976Z",
    fill: "url(#paint22_linear_246_104)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.522 98.7279C105.522 98.7279 105.949 95.8213 106.026 94.0928L105.592 90.8916C105.592 90.8916 106.274 93.3719 106.383 94.3486L105.522 98.7356V98.7279Z",
    fill: "#FF7F85"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.196 98.883C108.196 98.883 108.785 95.4493 108.723 93.7829L108.018 90.1089C108.018 90.1089 109.01 92.7985 109.15 94.0464C109.281 95.2943 108.545 98.542 108.545 98.542L108.204 98.883H108.196Z",
    fill: "#FF7F85"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3381 57.0661C88.7105 58.5311 90.0979 62.9414 90.0979 62.9414L90.0126 62.9879C89.5863 63.1817 87.7958 63.825 86.6719 61.2052C85.393 58.2133 86.2766 54.7641 88.9352 54.3223C88.9352 54.3223 89.8189 55.1129 91.3381 57.0661Z",
    fill: "#5E364C"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02994 16.1018V13.8307C8.02994 13.8307 3.25531 11.9395 2.92201 7.02535C2.55771 1.6849 7.7509 -0.0823388 10.456 0.00292248V16.1018H8.02994Z",
    fill: "url(#paint23_linear_246_104)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8899 16.1018V13.8307C12.8899 13.8307 17.6645 11.9395 17.9978 7.02535C18.3621 1.6849 13.1689 -0.0823388 10.4561 0.00292248V16.1018H12.8821H12.8899Z",
    fill: "url(#paint24_linear_246_104)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64258 14.079C7.64258 14.079 10.2624 12.8389 13.2621 14.048L13.0605 17.7608C13.0605 17.7608 10.7042 17.2415 7.91386 17.7608L7.64258 14.079Z",
    fill: "url(#paint25_linear_246_104)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91357 17.7604C7.91357 17.7604 10.3629 18.644 13.0603 17.7604C13.0603 17.7604 10.6807 16.7373 7.91357 17.7604Z",
    fill: "#D3646D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82861 2.49888C5.82861 2.49888 8.65774 7.69206 13.3704 8.04861C18.0752 8.40516 17.6412 6.75419 17.6412 6.75419C17.6412 6.75419 17.4784 1.67727 12.4867 0.499113C7.49508 -0.671292 5.82861 2.49888 5.82861 2.49888Z",
    fill: "url(#paint26_linear_246_104)"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7114 1.13443C11.7114 1.13443 12.2307 2.17307 13.3856 2.56837C14.5406 2.96367 15.1296 2.56837 15.1296 2.56837C15.1296 2.56837 14.0445 0.894151 11.7114 1.13443Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16992 11.6294C6.16992 11.6294 6.43346 12.3735 7.17756 12.7455C7.92165 13.1176 8.35571 12.8928 8.35571 12.8928C8.35571 12.8928 7.76663 11.6681 6.16992 11.6294Z",
    fill: "white"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0957 66.6538C43.0957 66.6538 44.3514 68.7776 46.6379 68.2273C48.6067 67.7545 49.3353 64.9951 49.3353 64.9951C49.3353 64.9951 46.8627 65.871 43.1035 66.6616L43.0957 66.6538Z",
    fill: "url(#paint27_linear_246_104)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8237 71.3741C48.8237 71.3741 49.6066 69.134 50.4437 69.041C50.4437 69.041 51.8234 70.5912 48.8237 71.3741Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_104",
    x1: 26.8904,
    y1: 101.629,
    x2: 14.8051,
    y2: 90.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#731653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_246_104",
    x1: 21.1266,
    y1: 95.6514,
    x2: 44.5094,
    y2: 70.8034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#46255E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_246_104",
    x1: 21.1266,
    y1: 95.6513,
    x2: 36.1645,
    y2: 79.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_246_104",
    x1: 0.555734,
    y1: 44.7015,
    x2: 41.1431,
    y2: 47.1626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#46255E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_246_104",
    x1: 5.19987,
    y1: 32.2713,
    x2: 20.5068,
    y2: 56.9612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_246_104",
    x1: 64.5371,
    y1: 78.7205,
    x2: 75.8916,
    y2: 9.9553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF9F9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB2B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_246_104",
    x1: 54.4956,
    y1: 44.7437,
    x2: 59.3038,
    y2: 27.6495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_246_104",
    x1: 29.9206,
    y1: 48.1538,
    x2: 32.7182,
    y2: 38.2077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_246_104",
    x1: 91.7328,
    y1: 33.2445,
    x2: 94.4444,
    y2: 23.6043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_246_104",
    x1: 59.6885,
    y1: 36.8163,
    x2: 61.357,
    y2: 30.8844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_246_104",
    x1: 33.2638,
    y1: 38.2727,
    x2: 34.6447,
    y2: 33.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_246_104",
    x1: 60.6771,
    y1: 80.421,
    x2: 71.8277,
    y2: 40.7782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_246_104",
    x1: 33.7074,
    y1: 66.2085,
    x2: 37.4306,
    y2: 52.9719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FAC8CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_246_104",
    x1: 55.7953,
    y1: 64.055,
    x2: 61.1155,
    y2: 45.1402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FAC8CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_246_104",
    x1: 45.017,
    y1: 70.4281,
    x2: 47.1346,
    y2: 62.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#731653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_246_104",
    x1: 70.7366,
    y1: 70.3917,
    x2: 102.075,
    y2: 79.2064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B44263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EF5666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_246_104",
    x1: 45.1109,
    y1: 71.9479,
    x2: 47.6145,
    y2: 63.0342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_246_104",
    x1: 71.7356,
    y1: 110.874,
    x2: 71.7356,
    y2: 74.3432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#46255E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_246_104",
    x1: 71.3558,
    y1: 111.098,
    x2: 71.3558,
    y2: 89.8297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_246_104",
    x1: 79.7814,
    y1: 111.494,
    x2: 62.9384,
    y2: 111.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#731653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_246_104",
    x1: 5.84216,
    y1: 41.1467,
    x2: 4.46323,
    y2: 35.0773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_246_104",
    x1: 106.545,
    y1: 100.416,
    x2: 91.2961,
    y2: 53.5123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#46255E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_246_104",
    x1: 107.466,
    y1: 100.116,
    x2: 98.2448,
    y2: 71.7513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_246_104",
    x1: 8.1152,
    y1: 16.3653,
    x2: 6.34021,
    y2: 0.398225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_246_104",
    x1: 12.8046,
    y1: 16.3653,
    x2: 14.5796,
    y2: 0.398225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_246_104",
    x1: 10.8205,
    y1: 18.0088,
    x2: 10.3167,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E98388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_246_104",
    x1: 5.82861,
    y1: 4.1731,
    x2: 17.6489,
    y2: 4.1731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C1F29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_246_104",
    x1: 46.2116,
    y1: 68.3203,
    x2: 46.2116,
    y2: 64.9951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FAC8CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityBoost);
export default __webpack_public_path__ + "static/media/productivity-boost.0b97dd13f75fffaaf5f3fa2e291af241.svg";
export { ForwardRef as ReactComponent };